import { useI18n } from "../i18n";
import { LangSwitch } from "./LangSwitch";
import { ArrowLeft, Coins } from "lucide-react";
import { creditsLeft } from "./TrialCard";

export const fmt = (s) => `${String(Math.floor(s / 60)).padStart(2, "0")}:${String(s % 60).padStart(2, "0")}`;

const Stat = ({ label, children, testId, className }) => (
  <div><p className="label">{label}</p><p className={className} data-testid={testId}>{children}</p></div>
);

export const GhostHeader = ({ active, elapsed, maxSeconds, user, wordCount, onBack }) => {
  const { t } = useI18n();
  return (
  <header className="flex flex-wrap items-center justify-between gap-4 fade-in">
    <div className="flex items-center gap-3">
      <button onClick={onBack} disabled={active} className="icon-btn" data-testid="back-home-btn" title={t("backHome")}><ArrowLeft size={16} /></button>
      <img src="/logo192.png" alt="Voci Oltre" className="w-12 h-12 logo-img" data-testid="session-logo" />
      <div>
        <h1 className="font-heading text-2xl sm:text-3xl font-black tracking-tight">VOCI OLTRE</h1>
        <p className="label mt-1">{t("sessionSub")}</p>
      </div>
    </div>
    <div className="flex flex-wrap items-center gap-6 font-mono text-sm">
      <LangSwitch disabled={active} />
      <Stat label={t("status")} testId="session-status" className={active ? "text-red blink" : "text-subtle"}>{active ? "● REC" : "○ OFF"}</Stat>
      <Stat label={t("time")} testId="session-timer" className="text-cyan">{fmt(elapsed)}<span className="text-subtle"> / {fmt(maxSeconds)}</span></Stat>
      <Stat label={t("credits")} testId="session-credits" className="text-amber flex items-center gap-1">
        {user?.is_plus ? "PLUS ∞" : <><Coins size={12} />{creditsLeft(user)}</>}
      </Stat>
      <Stat label={t("words")} testId="session-word-count" className="text-amber">{wordCount}</Stat>
    </div>
  </header>
  );
};
